import React, { useState } from "react";
import { GuideWrapper } from "./style";
import PropTypes from "prop-types";
import { BulletPoint, Input, Button } from "../../Elements";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";
import {
	EMAIL_INVALID,
	EMAIL_REQUIRED,
	NAME_REQUIRED,
} from "@website-builder/utilities-index";
import { isEmailValid } from "@website-builder/utilities-index";

const DEFUALT_ERROR_OBJECT = { error: false, message: "" };

let SUBMIT_ERROR = false;

const Guide = (props) => {
	const { header, bulletPoints, image, ctaText, hubPageId, context } = props;
	const { apiBaseUrl } = context;
	const apiEndPoint = `${apiBaseUrl}/resources/interested/${hubPageId}/`;

	const [form, setForm] = useState({
		first_name: "",
		email: "",
	});

	const [successObj, setSuccessObj] = useState({
		message: "",
		success: false,
	});

	const handleFormChange = (field, value) => {
		setForm({
			...form,
			[field]: value,
		});
	};

	const [errorObjects, setErrorObjects] = useState({
		email: DEFUALT_ERROR_OBJECT,
		first_name: DEFUALT_ERROR_OBJECT,
		form: DEFUALT_ERROR_OBJECT,
	});

	const resetFieldError = (field) =>
		setErrorObjects({
			...errorObjects,
			[field]: { ...DEFUALT_ERROR_OBJECT },
		});

	const handleFormSubmit = (e) => {
		e.preventDefault();
		resetFieldError("form");
		const isFormValid = validateForm();
		if (isFormValid) {
			postRequest();
		}
	};

	const validateForm = () => {
		let isFormValid = true;
		const errorObjUpdate = {};
		const { first_name, email } = form;
		const trimmedName = first_name.trim(),
			trimmedEmail = email.trim();

		if (!trimmedEmail) {
			errorObjUpdate.email = { error: true, message: EMAIL_REQUIRED };
			isFormValid = false;
		} else {
			if (!isEmailValid(trimmedEmail)) {
				isFormValid = false;
				errorObjUpdate.email = {
					error: true,
					message: EMAIL_INVALID,
				};
			}
		}
		if (!trimmedName) {
			errorObjUpdate.first_name = { error: true, message: NAME_REQUIRED };
			isFormValid = false;
		}

		setErrorObjects({ ...errorObjects, ...errorObjUpdate });
		return isFormValid;
	};

	const postRequest = () => {
		// Create Form Data as body
		const { first_name, email } = form;
		var body = new FormData();
		body.append("email", email);
		body.append("first_name", first_name);

		fetch(apiEndPoint, {
			method: "POST",
			body,
			referrerPolicy: "no-referrer-when-downgrade",
		})
			.then((res) => res.json())
			.then((response) => {
				const { result = "" } = response;
				if (result === "success") {
					SUBMIT_ERROR = false;
					setSuccessObj({
						message:
							"You’re on the list! We’ll send the resources to your mailbox!",
						success: true,
					});
				}
			})
			.catch((err) => {
				SUBMIT_ERROR = true;
				setSuccessObj({
					message: "Oops, try again!",
					success: false,
				});
			});
	};

	return (
		<GuideWrapper>
			<div className="container">
				<div className="imageWrapper">
					<div className="imageContainer">
						<CloudinaryImage
							url={image}
							lazyload
							sizes={{
								default: {
									width: 371,
								},
							}}
						/>
					</div>
				</div>
				<div className="contentWrapper">
					<div className="header">{header}</div>
					<div>
						{bulletPoints.map((text, index) => (
							<BulletPoint text={text} key={`${text}-${index}`} />
						))}
					</div>
					{!successObj.success ? (
						<form className="form" onSubmit={handleFormSubmit}>
							{SUBMIT_ERROR && (
								<div className="errorMessage">{successObj.message}</div>
							)}
							<div className="formContainer">
								<div className="formControl name">
									<Input
										type="text"
										placeholder="First name"
										value={form.first_name}
										errorObj={errorObjects.first_name}
										onFocus={() => resetFieldError("first_name")}
										onChange={(e) =>
											handleFormChange("first_name", e.target.value)
										}
									/>
								</div>
								<div className="formControl email">
									<Input
										type="email"
										placeholder="Email"
										value={form.email}
										errorObj={errorObjects.email}
										onFocus={() => resetFieldError("email")}
										onChange={(e) => handleFormChange("email", e.target.value)}
									/>
								</div>
							</div>
							<div>
								<Button btnType="submit" className="submitButton">
									{ctaText}
								</Button>
							</div>
						</form>
					) : (
						<div className="successMessage">{successObj.message}</div>
					)}
				</div>
			</div>
		</GuideWrapper>
	);
};

Guide.propTypes = {
	header: PropTypes.string,
	bulletPoints: PropTypes.array,
	image: PropTypes.string,
	ctaText: PropTypes.string,
	hubPageId: PropTypes.string,
};

Guide.defaultProps = {
	header: "",
	bulletPoints: [],
	image: "",
	ctaText: "",
	hubPageId: "",
};

export default Guide;
